import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=6776131c&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"
import style0 from "./Insights.vue?vue&type=style&index=0&id=6776131c&prod&scoped=true&lang=css"
import style1 from "./Insights.vue?vue&type=style&index=1&id=6776131c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6776131c",
  null
  
)

export default component.exports